import React from 'react';
import { Icon } from '@innovationnorway/cl-react';

const ToastContent = ({ title, text, success }: { title: string; text: string; success: boolean }) => {
  return (
    <div className="display--flex gap--2">
      <Icon
        prefix="fasr"
        iconName={success ? 'check-circle' : 'exclamation-circle'}
        className={`${success ? 'color--in-green-200' : 'color--red'}`}
      />
      <div>
        <div className="margin-bottom--0 font-size--large font-weight--bold color--in-black-100">{title}</div>
        <div className="color--in-black-100 font-size--medium">{text}</div>
      </div>
    </div>
  );
};

export default ToastContent;
